/* Zensil AI Chatbot — front-end logic.
   Reads config from the JSON block rendered by snippets/zensil-chatbot.liquid,
   keeps the conversation in sessionStorage, and talks to the Google Gemini API.

   Agentic shopping: the model is given tools (search_products, get_product,
   add_to_cart, get_cart) executed right here against Shopify's storefront
   Ajax APIs — so the assistant can look up live products and put items in the
   shopper's cart without any backend. */

(function () {
  var root = document.getElementById('zensil-chatbot');
  var cfgEl = document.getElementById('zcb-config');
  if (!root || !cfgEl || window.__zensilChatbotBound) return;
  window.__zensilChatbotBound = true;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  cfg.suggestions = (cfg.suggestions || [])
    .map(function (s) { return String(s).trim(); })
    .filter(Boolean);

  var STORAGE_KEY = 'zensil_chat_history_v2';
  var MAX_TURNS_SENT = 12; /* history entries included per API request */
  var MAX_TOOL_ROUNDS = 4; /* tool-call rounds allowed per user message */
  var FIRST_BYTE_TIMEOUT = 12000; /* abort + retry if Gemini stalls this long */
  /* Fingerprint of the bot's knowledge. When the prompt or model changes,
     saved conversations from the old knowledge are discarded — otherwise the
     bot's own outdated answers get replayed as context and it keeps
     repeating them. */
  var PROMPT_SIG = (cfg.model || '') + ':' + String((cfg.systemPrompt || '').length);

  var launcher = root.querySelector('.zcb-launcher');
  var panel = root.querySelector('.zcb-panel');
  var messagesEl = root.querySelector('.zcb-messages');
  var suggestionsEl = root.querySelector('.zcb-suggestions');
  var form = root.querySelector('.zcb-form');
  var input = root.querySelector('.zcb-input');
  var sendBtn = root.querySelector('.zcb-send');

  var history = loadHistory();
  var pending = false;

  /* ---------- History ---------- */

  function loadHistory() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      if (parsed && parsed.sig === PROMPT_SIG && Array.isArray(parsed.msgs) && parsed.msgs.length) {
        return parsed.msgs;
      }
    } catch (e) { /* fall through to fresh session */ }
    return [{ role: 'model', text: cfg.welcome }];
  }

  function saveHistory() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ sig: PROMPT_SIG, msgs: history.slice(-60) }));
    } catch (e) { /* storage full or unavailable — chat still works for this page */ }
  }

  /* ---------- Rendering ---------- */

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Minimal markdown: **bold**, [label](url), bullet dashes; everything else is escaped. */
  function formatText(text) {
    var s = escapeHtml(text.trim());
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g, function (m, label, url) {
      var external = /^https?:/.test(url) && url.indexOf(location.origin) !== 0;
      return '<a href="' + url + '"' + (external ? ' target="_blank" rel="noopener"' : '') + '>' + label + '</a>';
    });
    s = s.replace(/^\s*[-*]\s+/gm, '• ');
    return s;
  }

  function addMessage(role, text, opts) {
    var div = document.createElement('div');
    div.className = 'zcb-msg zcb-msg--' + (role === 'user' ? 'user' : (opts && opts.error ? 'error' : 'bot'));
    div.innerHTML = formatText(text);
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function showTyping() {
    var el = document.createElement('div');
    el.className = 'zcb-typing';
    el.setAttribute('aria-label', 'Assistant is typing');
    el.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return el;
  }

  function moneyFromRupees(amount) {
    var n = Number(amount);
    return 'Rs. ' + (isNaN(n) ? amount : n.toFixed(2));
  }

  function moneyFromPaise(amount) {
    return 'Rs. ' + (Number(amount) / 100).toFixed(2);
  }

  /* Product cards shown under the bot's reply after it searches the store. */
  function addProductCards(products) {
    if (!products.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'zcb-cards';
    products.slice(0, 3).forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'zcb-card';
      card.innerHTML =
        '<a class="zcb-card__media" href="' + escapeHtml(p.url) + '">' +
        (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a class="zcb-card__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
        '<div class="zcb-card__price">' + escapeHtml(moneyFromRupees(p.price)) + '</div>';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zcb-card__btn';
      if (p.available && p.first_variant_id) {
        btn.textContent = 'Add to cart';
        btn.addEventListener('click', function () {
          btn.disabled = true;
          btn.textContent = 'Adding…';
          tools.add_to_cart({ variant_id: p.first_variant_id, quantity: 1 }).then(function (res) {
            if (res.error) throw new Error(res.error);
            var link = document.createElement('a');
            link.className = 'zcb-card__btn zcb-card__btn--done';
            link.href = '/cart';
            link.textContent = '✓ Added · View cart';
            btn.replaceWith(link);
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          });
        });
      } else {
        btn.textContent = 'Sold out';
        btn.disabled = true;
      }
      card.appendChild(btn);
      wrap.appendChild(card);
    });
    messagesEl.appendChild(wrap);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function renderSuggestions() {
    suggestionsEl.innerHTML = '';
    /* Chips only make sense before the visitor has said anything */
    var hasUserMsg = history.some(function (m) { return m.role === 'user'; });
    if (hasUserMsg || !cfg.suggestions.length) return;
    cfg.suggestions.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zcb-chip';
      b.textContent = q;
      b.addEventListener('click', function () { send(q); });
      suggestionsEl.appendChild(b);
    });
  }

  function renderAll() {
    messagesEl.innerHTML = '';
    history.forEach(function (m) { addMessage(m.role, m.text); });
    renderSuggestions();
  }

  /* ---------- Shopping tools (Shopify storefront Ajax APIs) ---------- */

  var productsCache = null;

  function loadProducts() {
    if (productsCache) return Promise.resolve(productsCache);
    return fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productsCache = (data.products || []).map(function (p) {
          var img = p.images && p.images[0] && p.images[0].src;
          var variants = (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, price: v.price, available: v.available !== false };
          });
          var firstAvailable = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].available) { firstAvailable = variants[i]; break; }
          }
          return {
            title: p.title,
            handle: p.handle,
            url: '/products/' + p.handle,
            product_type: p.product_type || '',
            tags: (p.tags || []).join(' '),
            price: (firstAvailable || variants[0] || {}).price,
            available: !!firstAvailable,
            first_variant_id: firstAvailable ? firstAvailable.id : null,
            image: img,
            variants: variants
          };
        });
        return productsCache;
      });
  }

  /* Executed locally; results are fed back to the model as functionResponse. */
  var tools = {
    search_products: function (args) {
      var query = String((args && args.query) || '').toLowerCase();
      var terms = query.split(/[^a-z0-9]+/).filter(function (t) { return t.length > 2; });
      return loadProducts().then(function (products) {
        var scored = products.map(function (p) {
          var hay = (p.title + ' ' + p.product_type + ' ' + p.tags + ' ' + p.handle).toLowerCase();
          var score = 0;
          terms.forEach(function (t) { if (hay.indexOf(t) !== -1) score++; });
          return { p: p, score: score };
        }).filter(function (s) { return terms.length ? s.score > 0 : true; });
        scored.sort(function (a, b) { return b.score - a.score; });
        var results = scored.slice(0, 5).map(function (s) {
          return {
            title: s.p.title,
            url: s.p.url,
            handle: s.p.handle,
            price: moneyFromRupees(s.p.price),
            available: s.p.available,
            variant_id: s.p.first_variant_id,
            has_multiple_variants: s.p.variants.length > 1
          };
        });
        turnState.searchResults = scored.slice(0, 5).map(function (s) { return s.p; });
        return results.length ? { results: results } : { results: [], note: 'No products matched. The store may not carry this item.' };
      });
    },

    get_product: function (args) {
      var handle = String((args && args.handle) || '').replace(/^\/products\//, '');
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Product not found');
          return r.json();
        })
        .then(function (p) {
          return {
            title: p.title,
            url: '/products/' + p.handle,
            price: moneyFromPaise(p.price),
            available: p.available,
            description_excerpt: String(p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').slice(0, 400),
            variants: (p.variants || []).map(function (v) {
              return { variant_id: v.id, title: v.title, price: moneyFromPaise(v.price), available: v.available };
            })
          };
        })
        .catch(function (err) { return { error: err.message }; });
    },

    add_to_cart: function (args) {
      var id = Number(args && args.variant_id);
      var qty = Math.max(1, Number((args && args.quantity) || 1));
      if (!id) return Promise.resolve({ error: 'variant_id is required' });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (b) {
            return { error: b.description || b.message || 'Could not add to cart' };
          });
        }
        return r.json().then(function (item) {
          return fetch('/cart.js').then(function (cr) { return cr.json(); }).then(function (cart) {
            turnState.addedToCart = true;
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            return {
              added: item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : ''),
              quantity: qty,
              cart_item_count: cart.item_count,
              cart_total: moneyFromPaise(cart.total_price),
              cart_url: '/cart'
            };
          });
        });
      }).catch(function (err) { return { error: err.message }; });
    },

    get_cart: function () {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        return {
          item_count: cart.item_count,
          total: moneyFromPaise(cart.total_price),
          items: (cart.items || []).map(function (i) {
            return { title: i.product_title, quantity: i.quantity, line_total: moneyFromPaise(i.final_line_price) };
          }),
          cart_url: '/cart'
        };
      }).catch(function (err) { return { error: err.message }; });
    }
  };

  var TOOL_DECLARATIONS = [{
    functionDeclarations: [
      {
        name: 'search_products',
        description: 'Search the live Zensil store catalog. Returns up to 5 products with title, price, url, availability and variant_id for add_to_cart.',
        parameters: {
          type: 'OBJECT',
          properties: { query: { type: 'STRING', description: 'Keywords, e.g. "hammered kadhai" or "dosa tawa"' } },
          required: ['query']
        }
      },
      {
        name: 'get_product',
        description: 'Get full details of one product by handle: description, all size/variant options with their variant_id, price and stock.',
        parameters: {
          type: 'OBJECT',
          properties: { handle: { type: 'STRING', description: 'Product handle from a product url, e.g. "honeycomb-triply-dosa-tawa"' } },
          required: ['handle']
        }
      },
      {
        name: 'add_to_cart',
        description: 'Add a product variant to the shopper\'s cart. Use a variant_id from search_products or get_product. Returns the new cart count and total.',
        parameters: {
          type: 'OBJECT',
          properties: {
            variant_id: { type: 'STRING', description: 'Numeric variant id' },
            quantity: { type: 'NUMBER', description: 'Defaults to 1' }
          },
          required: ['variant_id']
        }
      },
      {
        name: 'get_cart',
        description: 'Get the shopper\'s current cart: items, quantities and total.',
        parameters: { type: 'OBJECT', properties: {} }
      }
    ]
  }];

  /* Per-message scratch used to drive UI extras (product cards, cart link). */
  var turnState = { searchResults: null, addedToCart: false };

  function execTool(fc) {
    var fn = tools[fc.call.name];
    if (!fn) return Promise.resolve({ error: 'Unknown tool ' + fc.call.name });
    return fn(fc.call.args || {}).catch(function (err) { return { error: err.message }; });
  }

  /* ---------- Gemini ---------- */

  /* One streaming request. Resolves { text, functionCalls }. Aborts and
     retries once if the API stalls before the first byte (free-tier queuing
     can otherwise freeze a reply for a minute). */
  function streamRequest(contents, generationConfig, onDelta, isRetry) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var stallTimer = controller && setTimeout(function () { controller.abort(); }, FIRST_BYTE_TIMEOUT);
    var gotFirstByte = false;

    return fetch(
      'https://generativelanguage.googleapis.com/v1beta/models/' +
        encodeURIComponent(cfg.model) + ':streamGenerateContent?alt=sse',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-goog-api-key': cfg.apiKey
        },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({
          system_instruction: { parts: [{ text: cfg.systemPrompt }] },
          contents: contents,
          tools: TOOL_DECLARATIONS,
          generationConfig: generationConfig
        })
      }
    ).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          var err = new Error((body.error && body.error.message) || ('HTTP ' + res.status));
          err.status = res.status;
          throw err;
        });
      }

      var text = '';
      var functionCalls = [];

      function handleLine(line) {
        line = line.trim();
        if (line.indexOf('data:') !== 0) return;
        var payload = line.slice(5).trim();
        if (!payload || payload === '[DONE]') return;
        var data;
        try { data = JSON.parse(payload); } catch (e) { return; }
        var cand = data.candidates && data.candidates[0];
        var parts = cand && cand.content && cand.content.parts;
        if (!parts) return;
        parts.forEach(function (p) {
          /* Keep the id + thoughtSignature: Gemini 3 models require them to be
             echoed back with the tool result or the follow-up round fails. */
          if (p.functionCall) functionCalls.push({ call: p.functionCall, sig: p.thoughtSignature });
          if (p.text && !p.thought) text += p.text;
        });
        if (text && onDelta) onDelta(text);
      }

      /* Older browsers without ReadableStream: fall back to one-shot text. */
      if (!res.body || typeof TextDecoder === 'undefined') {
        if (stallTimer) clearTimeout(stallTimer);
        return res.text().then(function (raw) {
          raw.split('\n').forEach(handleLine);
          return { text: text, functionCalls: functionCalls };
        });
      }

      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';

      function pump() {
        return reader.read().then(function (r) {
          if (!gotFirstByte) {
            gotFirstByte = true;
            if (stallTimer) clearTimeout(stallTimer);
          }
          if (r.done) {
            handleLine(buffer);
            return { text: text, functionCalls: functionCalls };
          }
          buffer += decoder.decode(r.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop();
          lines.forEach(handleLine);
          return pump();
        });
      }

      return pump();
    }).catch(function (err) {
      if (stallTimer) clearTimeout(stallTimer);
      var aborted = err && (err.name === 'AbortError' || /abort/i.test(err.message || ''));
      if (aborted && !isRetry) {
        return streamRequest(contents, generationConfig, onDelta, true);
      }
      throw err;
    });
  }

  /* Full agent turn: stream a reply; if the model calls tools, run them and
     continue until it produces the final text. onDelta receives the entire
     text-so-far across all rounds. */
  function callGemini(onDelta) {
    var contents = history.slice(-MAX_TURNS_SENT).map(function (m) {
      return { role: m.role, parts: [{ text: m.text }] };
    });

    var disableThinking = !/pro/i.test(cfg.model);
    var accumulated = '';
    var rounds = 0;

    function makeConfig(withThinkingOff) {
      var generationConfig = { temperature: 0.6, maxOutputTokens: 400 };
      if (withThinkingOff) generationConfig.thinkingConfig = { thinkingBudget: 0 };
      return generationConfig;
    }

    function step(generationConfig) {
      var base = accumulated;
      return streamRequest(contents, generationConfig, function (roundText) {
        if (onDelta) onDelta(base + (base ? '\n' : '') + roundText);
      }).then(function (res) {
        accumulated = base + (base && res.text ? '\n' : '') + res.text;
        if (res.functionCalls.length && rounds < MAX_TOOL_ROUNDS) {
          rounds++;
          contents.push({
            role: 'model',
            parts: res.functionCalls.map(function (fc) {
              var part = { functionCall: fc.call };
              if (fc.sig) part.thoughtSignature = fc.sig;
              return part;
            })
          });
          return Promise.all(res.functionCalls.map(execTool)).then(function (results) {
            contents.push({
              role: 'user',
              parts: results.map(function (result, i) {
                var fr = { name: res.functionCalls[i].call.name, response: { result: result } };
                if (res.functionCalls[i].call.id) fr.id = res.functionCalls[i].call.id;
                return { functionResponse: fr };
              })
            });
            return step(generationConfig);
          });
        }
        if (!accumulated) throw new Error('Empty response');
        return accumulated;
      });
    }

    return step(makeConfig(disableThinking)).catch(function (err) {
      /* Some models reject thinkingBudget — retry the whole turn without it. */
      if (disableThinking && err.status === 400) {
        accumulated = '';
        rounds = 0;
        contents = history.slice(-MAX_TURNS_SENT).map(function (m) {
          return { role: m.role, parts: [{ text: m.text }] };
        });
        return step(makeConfig(false));
      }
      throw err;
    });
  }

  function send(text) {
    text = (text || '').trim();
    if (!text || pending) return;

    if (!cfg.apiKey) {
      addMessage('model', cfg.strings.offline, { error: true });
      return;
    }

    addMessage('user', text);
    history.push({ role: 'user', text: text });
    saveHistory();
    renderSuggestions();
    input.value = '';

    pending = true;
    sendBtn.disabled = true;
    var typing = showTyping();
    var botDiv = null;
    var streamed = '';
    turnState = { searchResults: null, addedToCart: false };

    /* Warm the product cache in parallel so a tool round doesn't wait on it. */
    loadProducts().catch(function () { /* tools will surface the error if needed */ });

    callGemini(function (soFar) {
      streamed = soFar;
      if (!botDiv) {
        typing.remove();
        botDiv = addMessage('model', soFar);
      } else {
        botDiv.innerHTML = formatText(soFar);
        messagesEl.scrollTop = messagesEl.scrollHeight;
      }
    }).then(function (reply) {
      if (typing.parentNode) typing.remove();
      if (botDiv) botDiv.innerHTML = formatText(reply);
      else addMessage('model', reply);
      history.push({ role: 'model', text: reply });
      saveHistory();
      if (turnState.searchResults && !turnState.addedToCart) {
        addProductCards(turnState.searchResults);
      }
    }).catch(function (err) {
      if (typing.parentNode) typing.remove();
      if (streamed) {
        /* Connection dropped mid-reply — keep what already arrived. */
        history.push({ role: 'model', text: streamed });
        saveHistory();
      } else {
        addMessage('model', cfg.strings.error, { error: true });
      }
      if (window.console) console.warn('[Zensil chatbot] Gemini error:', err.message);
    }).finally(function () {
      pending = false;
      sendBtn.disabled = false;
      input.focus();
    });
  }

  /* ---------- Open / close ---------- */

  function setOpen(open) {
    root.classList.toggle('is-open', open);
    root.classList.add('was-opened');
    launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      messagesEl.scrollTop = messagesEl.scrollHeight;
      input.focus();
    }
  }

  launcher.addEventListener('click', function () {
    setOpen(!root.classList.contains('is-open'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) setOpen(false);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    send(input.value);
  });

  renderAll();
})();
